import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function CategoryGrid() {
  const categoryImages = [
    'https://readdy.ai/api/search-image?query=Anime%20storyboard%20style%20illustration%20with%20dramatic%20scene%20composition%2C%20story%20panels%20showing%20narrative%20progression%2C%20warm%20golden%20and%20rose%20tones%2C%20cinematic%20layout%2C%20artistic%20anime%20production%20design&width=600&height=400&seq=yanmu-cat-plot&orientation=landscape',
    'https://readdy.ai/api/search-image?query=Anime%20character%20design%20sheet%20with%20multiple%20character%20expressions%20and%20poses%2C%20warm%20lighting%2C%20professional%20animation%20character%20reference%2C%20detailed%20costume%20design%2C%20soft%20color%20palette&width=600&height=400&seq=yanmu-cat-char&orientation=landscape',
    'https://readdy.ai/api/search-image?query=Beautiful%20anime%20production%20showcase%20with%20sparkling%20visual%20effects%2C%20dynamic%20color%20gradients%2C%20artistic%20animation%20still%20frames%2C%20warm%20amber%20and%20coral%20lighting%2C%20professional%20quality&width=600&height=400&seq=yanmu-cat-highlight&orientation=landscape',
    'https://readdy.ai/api/search-image?query=Cozy%20home%20theater%20setup%20with%20anime%20posters%20on%20wall%2C%20warm%20ambient%20lighting%2C%20comfortable%20viewing%20environment%2C%20cinematic%20entertainment%20space%2C%20inviting%20atmosphere&width=600&height=400&seq=yanmu-cat-guide&orientation=landscape',
  ];

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            内容分类
          </h2>
          <p className="text-foreground-600 mt-2 text-sm">
            选择您感兴趣的内容类别，快速找到所需信息
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {categories.map((cat, index) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group block rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300"
            >
              <div className="aspect-[3/2] overflow-hidden">
                <img
                  src={categoryImages[index]}
                  alt={cat.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-700 mb-3">
                  <i className={`${cat.icon} text-xl`}></i>
                </div>
                <h3 className="text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors font-heading">
                  {cat.name}
                </h3>
                <p className="text-sm text-foreground-600 mt-1.5 leading-relaxed">
                  {cat.description}
                </p>
                <span className="inline-flex items-center gap-1 mt-3 text-xs font-medium text-primary-600">
                  浏览内容
                  <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}